import { createFileRoute } from "@tanstack/react-router";
import { marketingHead } from "@/lib/marketing/seo";
import { breadcrumbs } from "@/lib/marketing/ppl-schema";
import { MarketingShell } from "@/components/marketing/site/marketing-shell";
import { MarketingCta } from "@/components/marketing/site/marketing-cta";
import { SecurityHero } from "@/routes/v2/-components/sec-hero";
import { SecurityCompliance } from "@/routes/v2/-components/sec-compliance";
import { SecurityPrinciples } from "@/routes/v2/-components/sec-principles";
import { SecurityCommitments } from "@/routes/v2/-components/sec-commitments";
import { SecurityAsk } from "@/routes/v2/-components/sec-ask";
import { SecurityAria } from "@/routes/v2/-components/sec-aria";
import { SecurityFaq } from "@/routes/v2/-components/sec-faq";
import { faqs } from "@/routes/v2/-lib/security-data";

const SECURITY_FAQ_SCHEMA = {
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

function MarketingSecurity() {
  return (
    <MarketingShell>
      <SecurityHero />

      <SecurityCompliance />

      <SecurityPrinciples />

      <SecurityCommitments />

      <SecurityAsk />

      <SecurityAria />

      <SecurityFaq />

      {/* The closing band stays as the generic ask it always was. It is no
          longer the only one on the page, which was the problem with it. */}
      <MarketingCta
        title="Care for your residents. We'll protect the data."
        subtitle="Book a demo and see a platform that takes security as seriously as you do: or ask for the BAA, the security overview and the exit terms first, above."
      />
    </MarketingShell>
  );
}

export const Route = createFileRoute("/v2/security")({
  component: MarketingSecurity,
  head: () => ({
    ...marketingHead({
      title: "Security and compliance: HIPAA, the BAA and the audit trail | PEOPLE AI Workforce",
      description:
        "PEOPLE AI Workforce is HIPAA compliant, with a Business Associate Agreement accepted with every order. Role-based access, per-tenant data isolation, ESIGN/UETA e-signatures, immutable signed notes, presigned document storage and hourly encrypted off-site backups, and no third-party attestation implied that we do not hold.",
      path: "/v2/security",
      imageAlt: "PEOPLE AI Workforce. The AI workforce for senior living",
      schema: [SECURITY_FAQ_SCHEMA, breadcrumbs({ name: "Security", path: "/security" })],
    }),
  }),
});
